let currentTabNumber = null;

function tabMechanics(tabsent) {
  document.getElementById("tab1").style.background = "#eee";
  document.getElementById("tab2").style.background = "#eee";
  document.getElementById("tab3").style.background = "#eee";
  document.getElementById("tab4").style.background = "#eee";
  document.getElementById("tab5").style.background = "#eee";
  document.getElementById("tab6").style.background = "#eee";
  document.getElementById("tab7").style.background = "#eee";
  document.getElementById("tab1").style.color = "#666";
  document.getElementById("tab2").style.color = "#666";
  document.getElementById("tab3").style.color = "#666";
  document.getElementById("tab4").style.color = "#666";
  document.getElementById("tab5").style.color = "#666";
  document.getElementById("tab6").style.color = "#666";
  document.getElementById("tab7").style.color = "#666";

  document.getElementById("tab" + tabsent).style.background = "#666";
  document.getElementById("tab" + tabsent).style.color = "#fff";

  if (tabsent == 1) { // black pepper
    document.getElementById("headerimage-hero").style.backgroundImage =
      window.innerWidth > 1920
        ? "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/Hero_BlackPepper_3008.jpg)"
        : "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/hero_blackpepper.jpg)";
  } else if (tabsent == 2) { // red pepper
    document.getElementById("headerimage-hero").style.backgroundImage =
      window.innerWidth > 1920
        ? "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/Hero_redpeppers_3008.jpg)"
        : "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/Hero_redpeppers_1920.jpg)";
  } else if (tabsent == 3) { // seed spices
    document.getElementById("headerimage-hero").style.backgroundImage =
      window.innerWidth > 1920
        ? "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/Hero_seedspices_3008.jpg)"
        : "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/Hero_seedspices.jpg)";
  } else if (tabsent == 4) { // turmeric & ginger
    document.getElementById("headerimage-hero").style.backgroundImage =
      window.innerWidth > 1920
        ? "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/Hero_turmeric_3008.jpg)"
        : "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/Hero_turmeric_1920.jpg)";
  }else if (tabsent == 5) { // Cassia, Nutmeg, & Clove
    document.getElementById("headerimage-hero").style.backgroundImage =
      window.innerWidth > 1920
        ? "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/hero_CassiaNutmegClove_3008.jpg)"
        : "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/hero_CassiaNutmegClove_1920.jpg)";
  }else if (tabsent == 6) { // Garlic, & Onion
    document.getElementById("headerimage-hero").style.backgroundImage =
      window.innerWidth > 1920
        ? "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/hero_GarlicOnion_3008.jpg)"
        : "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/hero_GarlicOnion_1920.jpg)";
  }else if (tabsent == 7) { // Herbs
    document.getElementById("headerimage-hero").style.backgroundImage =
      window.innerWidth > 1920
        ? "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/Hero_Herbs_3008.jpg)"
        : "url(https://cdn.shopify.com/s/files/1/0486/5412/3169/files/Hero_Herbs_1920.jpg)";
  }
}

function resetTabStyles() {
  for (let i = 1; i <= 7; i++) {
    const tab = document.getElementById("tab" + i);
    if (tab) {
      tab.style.background = "#eee";
      tab.style.color = "#666";
    }
  }
}

function showReportsByTabNumber(tabNumber) {
  const classMap = {
    1: 'black-pepper-report',
    2: 'red-pepper-report',
    3: 'seed-spice-report',
    4: 'ginger-turmeric-report',
    5: 'cassia-nutmeg-clove-report',
    6: 'garlic-onion-report',
    7: 'herbs-report'
  };

  const allReportClasses = Object.values(classMap);

  // Toggle off if clicking the same tab again
  if (currentTabNumber === tabNumber) {
    currentTabNumber = null;

    // Show all
    allReportClasses.forEach(reportClass => {
      document.querySelectorAll('.' + reportClass).forEach(el => {
        if (!el.classList.contains('empty-message')) {
          el.style.display = '';
        }
      });
    });

    // Hide all empty messages again
    document.querySelectorAll('.empty-message').forEach(el => {
      el.style.display = 'none';
    });

    resetTabStyles();

    // Set tab=0 in the URL
    const newUrl = new URL(window.location);
    newUrl.searchParams.set('tab', 0);
    window.history.replaceState({}, '', newUrl);

    return;
  }

  currentTabNumber = tabNumber;

  // Push new tab number to URL
  const newUrl = new URL(window.location);
  newUrl.searchParams.set('tab', tabNumber);
  window.history.replaceState({}, '', newUrl);

  // Hide all report types
  allReportClasses.forEach(reportClass => {
    document.querySelectorAll('.' + reportClass).forEach(el => {
      el.style.display = 'none';
    });
  });

  // Show selected type
  const selectedClass = classMap[tabNumber];
  if (selectedClass) {
    document.querySelectorAll('.' + selectedClass).forEach(el => {
      el.style.display = '';
    });
  }

  tabMechanics(tabNumber);
}

function changetab(event, tabsent) {
  if (event.type == 'click' || event.keyCode == '32' || event.keyCode == '13') {
    event.preventDefault();
    showReportsByTabNumber(tabsent);
  }
}

function clearAllYears() {
  document.getElementById("reports_2026").style.display = "none";
  document.getElementById("reports_2025").style.display = "none";
  document.getElementById("reports_2024").style.display = "none";
  document.getElementById("reports_2023").style.display = "none";
  document.getElementById("reports_2022").style.display = "none";
  document.getElementById("reports_2021").style.display = "none";
  document.getElementById("reports_2020").style.display = "none";
}

var selectElement;
function changeTabsByYear() {
  clearAllYears();
  selectElement = document.querySelector('#sort_by').value;
  document.getElementById("reports_" + selectElement).style.display = "block";
}

window.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get('tab'); // e.g., ?tab=2

  if (tabParam !== null) {
    const tabNumber = Number(tabParam);

    if (tabNumber === 0) {
      currentTabNumber = null;

      const allReportClasses = [
        'black-pepper-report',
        'red-pepper-report',
        'seed-spice-report',
        'ginger-turmeric-report',
        'cassia-nutmeg-clove-report',
        'garlic-onion-report',
        'herbs-report'
      ];

      allReportClasses.forEach(reportClass => {
        document.querySelectorAll('.' + reportClass).forEach(el => {
          if (!el.classList.contains('empty-message')) {
            el.style.display = '';
          }
        });
      });

      // Hide all empty messages in unfiltered view
      document.querySelectorAll('.empty-message').forEach(el => {
        el.style.display = 'none';
      });

      resetTabStyles();
    } else if (!isNaN(tabNumber) && tabNumber >= 1 && tabNumber <= 7) {
      showReportsByTabNumber(tabNumber);
    }
  }
});
